import { render } from "./SettingsPanelView.vue?vue&type=template&id=4a3e6d27&ts=true"
import script from "./SettingsPanelView.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelView.vue?vue&type=script&lang=ts"

import "./SettingsPanelView.vue?vue&type=style&index=0&id=4a3e6d27&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__